import React from 'react';
import { CondensedHeader, CondensedLarge } from '@axiom/ui';
import type {
  AfcCandidateSearch,
  Candidate,
  LimitedCandidate,
  SavedCandidate,
  Taxonomy,
} from '@axiom/validation';

export type TalentPricingProps = {
  candidate:
    | Candidate
    | AfcCandidateSearch
    | SavedCandidate['candidate']
    | LimitedCandidate;
  taxonomy: Taxonomy;
  fullTimeDailyRate?: string | null;
  adHocHourlyRate?: string | null;
};

export const TalentPricing = ({
  candidate,
  taxonomy,
  fullTimeDailyRate,
  adHocHourlyRate,
}: TalentPricingProps) => {
  const { practiceAreas } = taxonomy;

  return (
    <>
      <CondensedHeader name="TALENT_PRICING_RATE">
        Starting at {fullTimeDailyRate} full-time weekly
      </CondensedHeader>
      {!!adHocHourlyRate &&
      candidate.primaryPracticeArea &&
      practiceAreas[candidate.primaryPracticeArea]?.fullName !==
        practiceAreas.LegalSupport?.fullName ? (
        <CondensedLarge name="TALENT_PRICING_ADHOC_RATE">
          Up to {adHocHourlyRate} for ad hoc hourly
        </CondensedLarge>
      ) : null}
    </>
  );
};
